import React from "react";
import { logo } from "../../../assets/img";
import { useNavigate } from "react-router-dom";



const Welcome = () => {
            const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <div className="glass-card">
        <h1 className="welcome-title">
          Welcome To <span>HR Management</span>
        </h1>

        <img src={logo} alt="Logo" className="welcome-logo" />

        <p className="welcome-text">
          Manage people and tasks effectively
        </p>

        <button className="welcome-btn mt-3" onClick={() => navigate("/main-page")}>
          Get Started
          <span className="btn-glow"></span>
        </button>
      </div>
    </div>
  );
};

export default Welcome;
